<template>
  <!-- <b-card>
<el-button @click="$router.back(1)">Voltar para De-para</el-button>
</b-card> -->
  <div class="depara-pendente">
      <b-modal @hide="setDefaultPlanoDeContas" size="lg" id="modal-justificar" title="Justificativa" ref="modal-justificar">
          <div class="table-responsive-sm">
              <table class="b-table table table-bordered table-striped bv-docs-table p-table">
                  <thead class="thead-default">
                      <tr>
                          <th>Marca</th>
                          <th>Tipo de Valor</th>
                          <th>Nome</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>
                            <div class="text-nowrap" translate="no">
                              <b><el-tag size="small" type="primary" effect="plain">{{ currentPlanoDeConta.marca.label }}</el-tag></b>
                            </div>
                          </td>
                          <td> {{ currentPlanoDeConta.tipoDoValor }}</td>
                          <td>
                              {{ currentPlanoDeConta.registroPendente.label  }}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div>
            <b>Justificativa:</b>
            <el-input
            v-model="justificativa"
            :rows="2"
            type="textarea"
            placeholder="Insira sua Justificativa"
           />
          </div>
          <template #modal-footer="{ hide }">
              <div class="float-right">
                  <el-button size="small" @click="hide()">Fechar</el-button>
                  <el-button size="small" icon="el-icon-document-add" type="primary" @click="handleOk">Salvar</el-button> 
              </div>
          </template>
      </b-modal>
      <b-modal v-model="showResultado" title="Franqueado - De-Para" size="lg" scrollable>
        <table class="b-table table table-bordered table-striped bv-docs-table p-table">
            <thead class="thead-default">
                      <tr>
                          <th>Status</th>
                          <th>Franqueado</th>
                          <th >Franqueador</th>
                          <th>Marca</th>
                          <th>Justificativa</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in resultadoAprovacoes" :key="row.planoDoFranqueado">
                          <td>
                            <div>
                              <i class="fas fa-check" v-if="row.observacao === stringSucess" style="color: teal"></i>
                              <i class="fas fa-times" v-else style="color: tomato"></i>
                              {{ row.observacao }}
                            </div>
                          </td>
                          <td> {{ row.planoDoFranqueado }} </td>
                          <td> {{ row.planoDoFranqueador }} </td>
                          <td> <el-tag size="small" type="primary" effect="plain">{{ row.marca }}</el-tag> </td>
                          <td>{{ row.justificativa }} </td>
                      </tr>
                  </tbody>
              </table>
            <template #modal-footer="{ hide }">
              <div class="float-right">
                  <el-button size="small" @click="hide()">Fechar</el-button>
              </div>
            </template>
      </b-modal>
      <el-table class="p-table" v-loading="tableLoading" :data="tableOptions.data" style="width: 100%;" stripe border @selection-change="selectRevisao" size="mini">
          <el-table-column type="selection" :selectable="handleValidateSelect" width="55" align="center"> </el-table-column>
          <el-table-column label="Plano de Contas" align="center">Franqueado
            <el-table-column prop="registroPendente.label" sortable align="left"> 
              <template slot="header">
                <span>Franqueado</span>
                <el-popover ref="filterNome" placement="bottom" trigger="click" width="400" @click.native.stop>
                  <div style="margin-bottom:5px">
                    <b-form-input size="sm" v-model="model.nome" placeholder="Pesquisar nome"></b-form-input>
                    <!-- <el-input class="input-filter" placeholder="Pesquisar nome" v-model="model.nome" size="mini"></el-input> -->
                  </div>
                  <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                  <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nome')">Limpar</el-button>
                  <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                </el-popover>
              </template>
            </el-table-column>
              <el-table-column prop="" label="Franqueador" align="center">
                  <template slot="header">
                      Franqueador
                  </template>
                  <template slot-scope="scope" v-if="scope.row">
                      <el-select v-loading="loadingPlanoDeConta" filterable clearable class="d-inline-block w-100" size="small" v-model="scope.row.valorSegundaColuna" placeholder="Selecione os planos de conta">
                          <el-option v-for="item in planosDeConta" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                      </el-select>
                  </template>
              </el-table-column>
          </el-table-column>
          <el-table-column
            prop="marca"
            label="Marcas"
            align="center"
            width="200">

            <template slot-scope="scope" v-if="scope.row">
              <el-tag size="small" type="primary" effect="plain">{{ scope.row.marca.label }}    </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Justificar" align="center" width="130">
            <template slot-scope="scope" v-if="scope.row">
                <el-button 
                  size="mini" 
                  icon="el-icon-edit"
                  :type="handleTypeBtn(scope.row.registroPendente.id)" 
                  v-b-modal.modal-justificar 
                  @click="() => handleOpenDialog(scope.row)" 
                >
                  {{  handleTitleBtb(scope.row.registroPendente.id) }}
                </el-button>
            </template>
          </el-table-column>

      </el-table><br />
      <el-pagination
        class="text-center"
        background
        layout="sizes, prev, pager, next"
        @size-change="paginacaoSize"
        @current-change="paginacaoCurrent"
        :page-size="tableOptions.paginacao.pageSize"
        :current-page.sync="tableOptions.paginacao.page"
        :total="tableOptions.paginacao.total"
        >
      </el-pagination>

      <AproveButton
        :loading="loadingBtns"
        v-show="enableBtn"
        @click="handleAprovar"
      />
  </div>
</template>
<script>
  import AproveButton from '../widget/AproveButton.vue';

  const viewModel = (val) => {
      return {
        deParaIds: val.deParaIds || [],
        marca: val.marca || null,
        valorPrimeiraColuna: val.registroPendente.id || '',
        valorSegundaColuna: val.valorSegundaColuna || ''
      }
  }

  export default {
    components: { AproveButton },
    props: ['tab'],
    data(){
      return {
        tempModel: [],
        model: {
          nome: ''
        },
        tipoPlanoDeConta: true, // receber = true | pagar = false
        planosDeConta: [],
        loadingPlanoDeConta: false,
        loadingBtns: false,
        tableOptions: {
          load: false,
          data: [],
          paginacao: {
            page: 1,
            pageSize: 20,
            total: 10
          }
        },
        currentPlanoDeConta: {
            registroPendente: {
                id: "",
                label: "",
                tags: null,
                default: false
            },
            tipoDoValor: "",
            marca: ""
        },
        justificativas: [],
        justificativa: '',
        showResultado: false,
        stringSucess: "Inserido com sucesso",
        resultadoAprovacoes: []
      }
    },
    computed:{
      enableBtn() {
        return this.tempModel.length ? true : false
      },
      tableLoading() {
        return this.tableOptions.load || this.loadingBtns
      }
    },
    methods: {
      // request
      async getRevisoes() {
        try {
          this.tableOptions.load = true;
          
          const response = await this.axios.get(this.$urls.DE_PARA_PENDENTE, {
            params: {
              page: this.tableOptions.paginacao.page,
              pageSize: this.tableOptions.paginacao.pageSize,
              //Order: '', // verificar como vai ser a ordenação
              CustomerId: this.$route.params.customerId,
              Marcas: this.$route.query.marcas,
              Visao: 'franqueado', // franqueado ou franqueador
              Nome: this.model.nome
            }
          });
          
          this.tableOptions.load = false
          
          if(response.status !== 200){
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
            return;
          }
          
          this.tableOptions.data = response.data.valores;
          this.tableOptions.paginacao.page = response.data.page;
          this.tableOptions.paginacao.total = response.data.total;

          
        } catch(err) {
          this.$notify.error({
            title: 'Erro interno',
            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
            position:'top-left'
          });
        } finally {
          this.tableOptions.load = false
        }
      },
      async listarPlanosDeConta() {
        try {
          this.loadingPlanoDeConta = true

          const response = await this.axios.get(this.$urls.LISTAR_PLANO_DE_CONTAS);
          
          if(response.status !== 200){
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
            return;
          }
          
          this.planosDeConta = response.data;

        } catch(err) {
          this.$notify.error({
            title: 'Erro interno',
            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
            position:'top-left'
          });
        } finally {
          this.loadingPlanoDeConta = false
        }
      },
      // methods
      selectRevisao(rows) {
        if(this.checkEmpity(rows)){
          this.$message.error('Por favor, selecione um plano de conta ou adicione uma justificativa');
        }
        this.tempModel = []
        rows.forEach((item) => {
          this.tempModel.push(viewModel(item));
        });
      },
      checkEmpity(rows){
        let currentSelect = rows[rows.length - 1];
        if(currentSelect){
          const hasJustificativa =  this.handleSearchJustificativa(currentSelect.registroPendente.id);
          const hasPlanoConta = this.tableOptions.data.find(p => p.registroPendente.id === currentSelect.registroPendente.id);
          return !hasJustificativa && !hasPlanoConta.valorSegundaColuna;
        }
        return false;
      },
      handleOpenDialog(row){
        this.isEditar(row) 
          ?  this.handleEdit(row)
          :  this.currentPlanoDeConta = row;
      },
      handleRemoveJustificativa(id = this.currentPlanoDeConta.registroPendente.id){
        const newJustificativas =  this.justificativas.filter(justificativa => {
           return !(justificativa.registroPendente.id ===  id)
          });

          this.justificativas = newJustificativas;
      },
      handleEditJustificativa({registroPendente}){
       const newJustificativas =  this.justificativas.map(j => {
        if(j.registroPendente.id === registroPendente.id){
          j.justificativa = this.justificativa;
        }
        return j;
       });

          this.justificativas = newJustificativas;
      },
      handleOk(){
        const isEditar = this.isEditar(this.currentPlanoDeConta);

        const applyEdit = isEditar && this.justificativa;

        if (!this.validateJustificativa(this.justificativa)){
          this.$notify({
                        title: 'Houve um erro',
                        message: `Justificativa '${this.justificativa}' inválida, deve conter ao menos 3 caracteres válidos`,
                        position: 'top-right',
                        customClass: 'bg-dark'
                });
          return;
        }

        if(applyEdit){
          this.handleEditJustificativa(isEditar);
          this.$bvModal.hide('modal-justificar')
          return;
        }

        if(!this.justificativa){
          this.handleRemoveJustificativa();
          this.$bvModal.hide('modal-justificar');
          return;
        }

        const newJustificativa = Object.assign({}, {
          justificativa: this.justificativa, 
          ...this.currentPlanoDeConta 
        });

        this.justificativas.push(newJustificativa);
        const { valorSegundaColuna } = newJustificativa;
     
        if(valorSegundaColuna){
          this.tableOptions.data.forEach(data => {
          const hasValue = data.valorSegundaColuna === valorSegundaColuna;
          if(hasValue) data.valorSegundaColuna = null;
        });
        }
        

        this.$bvModal.hide('modal-justificar')
      },
      handleSearchJustificativa(id){
       const hasJustificativa = this.justificativas.find(justificativa => justificativa.registroPendente.id === id)
       return !!hasJustificativa;
      },
      handleTitleBtb(id){
        return this.handleSearchJustificativa(id) 
          ? 'Editar Justificativa' 
          : 'Justificar';
      },
      handleTypeBtn(id){
        return this.handleSearchJustificativa(id) 
          ? 'warning' 
          : 'primary';
      },
      handleEdit(row){
        const valueToEdit = this.isEditar(row);
        this.justificativa = valueToEdit.justificativa;
        this.currentPlanoDeConta = valueToEdit;
      },
      setDefaultPlanoDeContas(){
       this.currentPlanoDeConta = {
            registroPendente: {
                id: "",
                label: "",
                tags: null,
                default: false
            },
            tipoDoValor: "",
            marca: ""
        }
       this.justificativa = '';
      },
      isEditar(row){
       const rowId = row.registroPendente.id;
       const hasValue = this.justificativas
        .find(justificativa => justificativa.registroPendente.id === rowId);
     
        return hasValue;
      },
      paginacaoSize(val){
          this.tempModel = []
          this.tableOptions.paginacao.pageSize = val
          this.tableOptions.paginacao.page = 1
          this.getRevisoes()
      },
      paginacaoCurrent(val){
        this.tempModel = []
        this.tableOptions.paginacao.page = val
        this.getRevisoes()
      },
      async handleAprovar(){
        this.loadingBtns = true

        try {
          const payload = this.handleGetPayload();

          const response = await this.axios.post(this.$urls.CRIAR_FRANQUEADO_DEPARA, payload);
          if(response.status === 200){
            const { data } = response;
            this.resultadoAprovacoes = data;
            this.showResultado = true;
          }

          this.handleGetPlanos();

        } catch(err) {
          console.error('Erro ao aprovar de-para pendente: ',err)
        } finally {
          this.loadingBtns = false
        }
      },
      handleGetPayload(){
       const CustomerId = this.$route.params.customerId || '';
       const allValues = this.tempModel.map(value => {
          const PlanoFranqueadoId = value.valorPrimeiraColuna || '';
          const PlanoFranqueadorId = value.valorSegundaColuna || '';
          const Marca = value.marca ? value.marca.id : '';
     
          const getJustficativa = this.justificativas.find((value => {
            return value.registroPendente.id === PlanoFranqueadoId;
          }));

          const Justificativa = getJustficativa 
          ? getJustficativa.justificativa 
          : '';

          return {
            PlanoFranqueadoId,
            PlanoFranqueadorId,
            Justificativa,
            Marca,
            CustomerId
          }
        });

        const cleanPayLoad = allValues.filter(value => {
          const linhaValida = value.Justificativa || value.PlanoFranqueadorId;
          return linhaValida;
        });

        return cleanPayLoad;
      },
      cleanJustificativas(arrayPlanoDecontasID){
        const isValid = arrayPlanoDecontasID && arrayPlanoDecontasID.length;
          if(isValid){
            arrayPlanoDecontasID.forEach(id => {
            this.handleRemoveJustificativa(id);
          });
        }
      },
      handleValidateSelect(value){
        const id = value.registroPendente.id;

        const planoConta = this.tableOptions.data.find(plano => {
          const enableSelect =  plano.valorSegundaColuna && plano.registroPendente.id === id;
          return  enableSelect;
        });
        const justificativas =  this.justificativas.find(plano => {
          return plano.registroPendente.id === id;
        });
        const isValid = planoConta || justificativas;
        return isValid
        
      },
      handleGetPlanos(){
        this.getRevisoes()
         this.listarPlanosDeConta()
      },
      validateJustificativa(text) {
        // Remove espaços
        const trimmedText = text.trim();

        // Verificar se o texto tem pelo menos 3 caracteres
        if (/^[\w\sà-úÀ-Ú.,!?()\-"'&*%$#@+/\\:;<>[\]]{3,}$/.test(trimmedText)) {
          return true; // Texto é válido
        } else {
          return false; // Texto não é válido
        }
      },
      setFilter() {
        this.tableOptions.paginacao.page = 1
        this.getRevisoes();
      },
      clearFilter(name) {
        this.model[name] = ''
        this.getRevisoes();
      }
    },
    watch:{
      'tableOptions.data': {
        deep:true,
        handler: function(value){
        const onlyValidValues = value.map(v => {
          if(v.valorSegundaColuna){
            return v.registroPendente.id
          }
        })
          .filter(Boolean);
          
        this.cleanJustificativas(onlyValidValues);
      }
      },
    },
    mounted() {
      this.handleGetPlanos();
    }
  }
</script>
<style lang="scss" scoped>
.switch-plano {
  float: right;
}
</style>
